import React from "react";
import { Contact } from "./contact";
import JsonData from "../data/data.json";


export const AGBs = () => {
    return (
        <div id="agbs">
            <div className="container">
                <div className="section-title impressum text-center">
                    <h1>AGB</h1>
                </div>

                <div className="row">
                    <div className="col-md-8 col-md-offset-2 text-center">

                        <h4>Haftung für Inhalte und Links</h4>
                        <p>
                            Für die Richtigkeit, Vollständigkeit und Aktualität der auf dieser Website bereitgestellten Informationen
                            übernimmt die Merdovic Trockenbau GmbH keine Haftung oder Garantie.
                            Dieser Haftungsausschluss gilt ebenso für den Inhalt von Websites, auf die per Hyperlink verwiesen wird.
                            Für die Inhalte solcher verlinkten Websites sind ausschließlich deren Betreiber verantwortlich.
                            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für Inhalte externer Links.
                        </p>

                        <h4>Copyright und Urheberrecht</h4>
                        <p>
                            Die Merdovic Trockenbau GmbH ist bestrebt, die Urheberrechte der verwendeten Grafiken, Fotos und Texte zu beachten,
                            selbst erstellte Inhalte zu nutzen oder auf lizenzfreie Materialien zurückzugreifen.
                            Alle innerhalb dieses Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen
                            unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts
                            und den Besitzrechten der jeweiligen eingetragenen Eigentümer.
                            Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen,
                            dass Markenzeichen nicht durch Rechte Dritter geschützt sind.
                            Das Copyright für veröffentlichte, von der Merdovic Trockenbau GmbH selbst erstellte Objekte
                            bleibt allein beim Unternehmen.
                            Eine Vervielfältigung oder Verwendung solcher Grafiken, Fotos oder Texte
                            in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung
                            der Merdovic Trockenbau GmbH nicht gestattet.
                        </p>

                        <h4>Rechtswirksamkeit</h4>
                        <p>
                            Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage
                            nicht, nicht mehr oder nicht vollständig entsprechen sollten,
                            bleiben die übrigen Teile in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
                        </p>

                        <h4>Geltungsbereich</h4>
                        <p>
                            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und sonstigen Leistungen
                            der Merdovic Trockenbau GmbH, soweit nicht ausdrücklich etwas anderes vereinbart wurde.
                            Abweichende Bedingungen des Auftraggebers erkennen wir nur an, wenn ihrer Geltung ausdrücklich zugestimmt wurde.
                        </p>

                        <h4>Schlussbestimmungen</h4>
                        <p>
                            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                            Gerichtsstand für alle Streitigkeiten aus Vertragsverhältnissen ist, soweit gesetzlich zulässig, der Sitz der Merdovic Trockenbau GmbH.
                        </p>
                    </div>
                </div>
            </div>
            <Contact data={JsonData.Contact} />
        </div>
    );
};
